const asset = {
    // Skills
    logoHTML: require('../Assets/languages/html5-original.svg').default,
    logoCSS: require('../Assets/languages/css3-original.svg').default,
    logoJavaScript: require('../Assets/languages/javascript-original.svg').default,
    logoTypeScript: require('../Assets/languages/typescript-original.svg').default,
    logoReact: require('../Assets/languages/react-original.svg').default,
    logoRedux: require('../Assets/languages/redux-original.svg').default,
    logoNextjs: require('../Assets/languages/nextjs-original.svg').default,
    logoNodejs: require('../Assets/languages/nodejs-original.svg').default,
    logoExpressjs: require('../Assets/languages/express-original.svg').default,
    logoMongoDB: require('../Assets/languages/mongodb-original.svg').default,
    logoPHP: require('../Assets/languages/php-plain.svg').default,
    logoLaravel: require('../Assets/languages/laravel.svg').default,
    logoMySQL: require('../Assets/languages/mysql-plain.svg').default,
    logoThreejs: require('../Assets/languages/threejs-original.svg').default,
    logoGSAP: require('../Assets/languages/gsap-original.svg').default,
    logoSass: require('../Assets/languages/sass-original.svg').default,
    logoTailwindcss: require('../Assets/languages/tailwindcss-plain.svg').default,
    logoFigma: require('../Assets/languages/figma-original.svg').default,
    logoMaterialUI: require('../Assets/languages/materialui-original.svg').default,
    logoWordpress: require('../Assets/languages/wordpress-plain.svg').default,
    logoPython: require('../Assets/languages/python-original.svg').default,
    logoAWS: require('../Assets/languages/aws-original.svg').default,
    logoPostman: require('../Assets/languages/postman-original.svg').default,
    logoJest: require('../Assets/languages/jest-plain.svg').default,
    logoCypress: require('../Assets/languages/cypress.svg').default,
    logoGit: require('../Assets/languages/git-original.svg').default,

    // Social 
    logoGithub: require('../Assets/socials/Github - Negative.svg').default,
    logoLinkedIn: require('../Assets/socials/LinkedIn - Negative.svg').default,

    // Send Arrow
    Arrow: require('../Assets/Arrow.svg').default,

    // Projects
    ElectronicsStore: require('../Assets/projects/ElectronicsStore.png'),
    SportsNexus: require('../Assets/projects/SportsNexus.png'),
    ApexWeather: require('../Assets/projects/ApexWeather.png'),
    LuxuryCuts: require('../Assets/projects/LuxuryCuts.png'),
    WorkBridge: require('../Assets/projects/WorkBridge.png'),
    YegDealership: require('../Assets/projects/YegDealership.png'),
    WildRydes: require('../Assets/projects/WildRydes.png'),
    ElectronicsStoreGif: require('../Assets/projects/ElectronicsStore.gif'),
    SportsNexusGif: require('../Assets/projects/SportsNexus.gif'),
    ApexWeatherGif: require('../Assets/projects/ApexWeather.gif'),
    LuxuryCutsGif: require('../Assets/projects/LuxuryCuts.gif'),
    WorkBridgeGif: require('../Assets/projects/WorkBridge.gif'),
    YegDealershipGif: require('../Assets/projects/YegDealership.gif'),
    WildRydesGif: require('../Assets/projects/WildRydes.gif'),
}

export default asset;